import {
  createGalleryStore,
  CreateRegistrationStoreProvider,
} from 'components/CreateRegistration/CreateRegistrationStore';
import { renderComponent } from 'utils/RenderingUtils';
import { IPickOrCreateDialogProps } from './PickOrCreateDialog';

export async function renderPickOrCreateDialog(props: IPickOrCreateDialogProps, callback?: () => void) {
  const container = document.createElement('div');
  container.className = 'dp-pick-or-create-dialog-host';
  document.body.appendChild(container);

  const { PickOrCreateDialog } = await import('./PickOrCreateDialog');

  return renderComponent({
    container,
    component: (
      <CreateRegistrationStoreProvider createStore={createGalleryStore}>
        <PickOrCreateDialog {...props} />
      </CreateRegistrationStoreProvider>
    ),
    callback,
    autoUnmount: true,
  });
}
